<template>
  <div>
    <el-dialog v-model="dialogVisible" title="未缴记录" :close-on-click-modal="false" width="1400px" center>
      <el-form ref="searchForm" :model="searchForm" :inline="true" @keyup.enter="getData">
        <el-form-item label="车牌号" prop="car_number">
          <el-input v-model="searchForm.car_number" placeholder="请输入车牌号" clearable></el-input>
        </el-form-item>
        <el-form-item label="出场抓拍时间" prop="dep_start_time">
          <el-date-picker v-model="detectedTime" type="datetimerange" range-separator="到" start-placeholder="开始时间"
            end-placeholder="结束时间" value-format="YYYY-MM-DD HH:mm:ss" style="width:360px"
            @change="changeDetectedTime" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">搜索</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>

      <el-table v-loading="loading" :data="tableData" :max-height="maxH" empty-text="暂无数据">
        <el-table-column prop="car_number" label="车牌号" width="120"> </el-table-column>
        <el-table-column prop="all_price" label="订单金额" width="90"> </el-table-column>
        <el-table-column prop="cut_price" label="优惠金额" width="90"> </el-table-column>
        <el-table-column prop="paid_price" label="实收金额" width="90"> </el-table-column>
        <el-table-column prop="price" label="待缴金额" width="90">
          <template #default="scope">
            <span style="color:#DD0B0B">{{ scope.row.price }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="ent_time" label="入场时间" width="180"> </el-table-column>
        <el-table-column prop="detected_time" label="出场时间" width="180"> </el-table-column>
        <el-table-column prop="parking_time" label="停车时长" width="180"> </el-table-column>
        <el-table-column prop="rule_name" label="收费规则" width="100"> </el-table-column>
        <el-table-column prop="ent_gate" label="入场通道" width="120"> </el-table-column>
        <el-table-column prop="dep_gate" label="出场通道"> </el-table-column>
      </el-table>
      <el-pagination :hide-on-single-page="false" layout="prev, pager, next" :page-size="searchForm.size"
        :total="total" @current-change="currentChange">
      </el-pagination>
    </el-dialog>
  </div>
</template>

<script>
import * as API_index from "@/api/index";

export default {
  name: 'DialogUnpayRecord',
  data() {
    return {
      dialogVisible: false,
      loading: false,
      maxH: 500,
      searchForm: {
        park_id: this.getStore('park_id'),
        car_number: '',
        dep_start_time: undefined, // 出场抓拍时间
        dep_end_time: undefined, // 出场抓拍时间
        page: 1,
        size: 15,
      },
      detectedTime: [],
      total: 0,
      tableData: [],
    }
  },
  methods: {
    init() {
      this.dialogVisible = true
      this.searchForm.page = 1
      this.getData()
    },
    handleSearch() {
      this.searchForm.page = 1
      this.getData()
    },
    currentChange(e) {
      this.searchForm.page = e
      this.getData()
    },
    changeDetectedTime(e) {
      if (e) {
        this.searchForm.dep_start_time = e[0]
        this.searchForm.dep_end_time = e[1]
      } else {
        this.searchForm.dep_start_time = undefined
        this.searchForm.dep_end_time = undefined
      }
    },
    getData() {
      this.loading = true
      API_index.getRecordUnpayOrder(this.searchForm).then(res => {
        this.loading = false
        this.tableData = res.data
        this.total = res.total
      }).catch(() => {
        this.loading = false
      })
    },
    resetForm() {
      this.$refs.searchForm.resetFields()
      this.detectedTime = []
      this.searchForm.dep_start_time = undefined
      this.searchForm.dep_end_time = undefined
      this.searchForm.page = 1
      this.getData()
    },
  },
}
</script>
<style lang="scss" scoped>
</style>
